import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { ReleaseFixedAdminFeedbacksAPI } from '../../../../api/AdminAPI';

/**
 * ReleaseFixedBar - Faixa "pedidos corrigidos aguardando deploy" com o botão que libera
 * todos de uma vez depois do deploy (status Disponível + aviso no sino e por e-mail).
 * Some quando não há pedido corrigido.
 *
 * @param {Object} props
 * @param {number} props.count - pedidos em "fixed"
 * @param {Function} props.onDone - (response) => void; response = { success, released, notified, error }
 */
function ReleaseFixedBar({ count, onDone }) {
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!count) return null;

  const handleConfirm = () => {
    setLoading(true);
    ReleaseFixedAdminFeedbacksAPI((response) => {
      setLoading(false);
      setConfirming(false);
      if (onDone) onDone(response);
    });
  };

  const label = count === 1 ? '1 pedido corrigido' : `${count} pedidos corrigidos`;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          mb: 2,
          px: 2,
          py: 1.5,
          borderRadius: '12px',
          border: '1px solid #BBDEFB',
          bgcolor: '#E3F2FD',
        }}
      >
        <Typography variant="body2" sx={{ color: '#1565C0' }}>
          <strong>{label}</strong> aguardando deploy. Depois do deploy, libere para avisar quem enviou.
        </Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<RocketLaunchOutlinedIcon />}
          onClick={() => setConfirming(true)}
          sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
        >
          Liberar corrigidos
        </Button>
      </Box>

      <ConfirmDialog
        isOpen={confirming}
        title={`Liberar ${label}?`}
        message="Eles passam para Disponível e cada pessoa que enviou recebe o aviso no sino e por e-mail. Faça isso só depois que o deploy estiver no ar."
        confirmLabel="Liberar e avisar"
        variant="info"
        loading={loading}
        onConfirm={handleConfirm}
        onCancel={() => setConfirming(false)}
      />
    </>
  );
}

export default ReleaseFixedBar;
